// mobile header search bar js start here

document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function(){
  const elclose = document.querySelector('.mobilesearchmainsecc button.button.predictive-search__close-modal-button');
  if (elclose) {
    elclose.style.display = "none";
  }
  },980);
});

document.addEventListener("DOMContentLoaded", function() {
  function initSearchWatcher() {
    const searchInput = document.querySelector(".mobilesearchmainsecc  input#Search");
    const resultsDiv = document.querySelector(".shopify-section-group-header-group .mobilesearchmainsecc  .predictive-search-form__content-wrapper");
    const resetBtn   = document.querySelector(".mobilesearchmainsecc button.button-unstyled.predictive-search__reset-button");

    if (!searchInput || !resultsDiv || !resetBtn) {
      setTimeout(initSearchWatcher, 300);
      return;
    }

    resultsDiv.style.display = "none";
    resetBtn.style.display = "none";

    searchInput.addEventListener("input", function() {
      if (this.value.trim().length > 0) {
        resultsDiv.style.display = "block";
        resetBtn.style.display = "block";
      } else {
        resultsDiv.style.display = "none";
        resetBtn.style.display = "none";
      }
    });
  }

  initSearchWatcher();
});



// dekstop search bar css (use this if using other js that shows product card on same page)
/*
document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    const closeBtnDek = document.querySelector('.header__row button.button.predictive-search__close-modal-button');
    if (closeBtnDek) {
      closeBtnDek.style.display = "none";
    }
  }, 1080);
});

document.addEventListener("DOMContentLoaded", function() {
  function initDekstopSearchWatcher() {
    setTimeout(function() {
      const searchFieldDek = document.querySelector(".header__row input#Search");
      const resultsWrapperDek = document.querySelector(".header__row .predictive-search-form__content-wrapper");
      const resetButtonDek = document.querySelector(".header__row button.button-unstyled.predictive-search__reset-button");

      if (!searchFieldDek || !resultsWrapperDek || !resetButtonDek) {
        setTimeout(initDekstopSearchWatcher, 400);
        return;
      }

      resultsWrapperDek.style.display = "none";
      resetButtonDek.style.display = "none";

      // Show/hide results based on typing
      searchFieldDek.addEventListener("input", function() {
        if (this.value.trim().length > 0) {
          resultsWrapperDek.style.display = "block";
          resetButtonDek.style.display = "block";
        } else {
          resultsWrapperDek.style.display = "none";
          resetButtonDek.style.display = "none";
        }
      });

      // Hide results + reset when reset button is clicked
      resetButtonDek.addEventListener("click", function() {
        searchFieldDek.value = ""; // clear the input
        resultsWrapperDek.style.display = "none";
        resetButtonDek.style.display = "none";
      });
    }, 900);
  }

  initDekstopSearchWatcher();
});
*/


/* ----------- mobile header search bar js end here ----------------- */


// testimonial slider js start

setTimeout(function(){



$('.testi_slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true
});
},500)

// testimonial slider js end


// footer menu

if(window.innerWidth < 767){
  var footermenu = document.querySelectorAll('.footermenu li.menu__item.paragraph');
footermenu.forEach(function(menu){
    menu.addEventListener('click',function(){
        this.classList.toggle('active')
    })
})
}

// code for read more content - collection page

function toggleReadMore() {
  const dots = document.querySelector(".dots");
  const moreText = document.querySelector(".more-text");
  const btn = document.querySelector(".read-more-btn");

  if (moreText.style.display === "none" || moreText.style.display === "") {
    moreText.style.display = "inline";
    dots.style.display = "none";
    btn.textContent = "Read Less";
  } else {
    moreText.style.display = "none";
    dots.style.display = "inline";
    btn.textContent = "Read More";
  }
}
// code for judgeme star layout change - collection page

document.addEventListener("DOMContentLoaded", function() {
  const jdgmBadges = document.querySelectorAll('.jdgm-widget.jdgm-preview-badge');

  jdgmBadges.forEach(badge => {
    const prevBadge = badge.querySelector('.jdgm-prev-badge');
    if (!prevBadge) return;

    const rating = prevBadge.getAttribute('data-average-rating');
    const reviewCount = prevBadge.getAttribute('data-number-of-reviews');

    const customBadge = document.createElement('div');
    customBadge.className = 'custom-review-badge';
    customBadge.innerHTML = `
      <span class="custom-review-star">★</span>
      <span class="custom-review-text">${rating} <span>(${reviewCount})</span></span>
    `;

    badge.innerHTML = '';
    badge.appendChild(customBadge);
  });
});